<template>
  <div>
    <Addresses />
  </div>
</template>

<script>
import get from "lodash/get";
import { Page, Sort } from "@syncfusion/ej2-vue-grids";
import { GetDataManagerNew } from "../../../ds";
import errorResponse from "../../../helpers/error";
import { getFamilyTypeOptions } from "../../../helpers/options";
import Addresses from "./Addresses";
import Members from "./Members";

export default {
  name: "Settings",

  components: {
    Addresses,
    Members,
  },

  data() {
    const dm = GetDataManagerNew("auth_family");
    // const familyTypeOptions = getFamilyTypeOptions(this);

    const { name, f_type } = get(
      this.$store,
      "state.connections.current.family"
    );

    return {
      dm: dm,
      error: errorResponse(),
      loading: false,
      form: {
        name: name,
        type: f_type,
      },
      // familyTypeOptions: familyTypeOptions,
    };
  },
  provide: {
    grid: [Page, Sort],
  },
  computed: {
    familyTypeOptions() {
      return getFamilyTypeOptions(this);
    },
  },
  mounted() {},

  beforeDestroy() {},

  methods: {
    onSubmit() {
      const id = get(this.$store, "state.connections.current.family.id");
      const requestParams = {
        id: id,
        name: this.form.name,
        f_type: this.form.type,
      };
      this.error.reset();
      this.dm
        .update("", requestParams)
        .then((response) => {
          this.$store.dispatch("toaster/add", {
            title: "OK!",
            text: this.$t("family.settings.profile.msg_success"),
            color: "success",
            autohide: true,
          });
          this.$store.dispatch("connections/currentRefresh");
        })
        .catch((response) => {
          const body = JSON.parse(response[0].error.response);
          this.modal.error.set(body.errors);
        });
    },
  },
};
</script>
